import { IModelMapping } from "./generic/model.mapping";
import { ShippingPutRequestDtoModel } from "../models/shipping/dto/shipping-put-dto.model";
import { IShippingDtoModel } from "../models/shipping/dto/shipping.dto.model";
import { IDefaultShipToAddressModel } from "../models/shipping/shipping.model";
import { IShippingModel } from "../models/shipping//shipping.model";
import { ISavedAddressDetailsDtoModel } from "../models/saved-address/dto/saved-address-details-dto.model";
import { ISavedAddressDtoModel } from "../models/saved-address/dto/saved-address-dto.model";
import { ISavedShipToAddressPostDtoModel } from "../models/saved-address/dto/saved-ship-to-address-post-dto.model";
import { IJcontrolShippingMethodDtoModel } from "../models/legacy-info/jcontrol-customer-message-dto.model";
import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";
import { IPaymentModel } from "../models/payment/payment.model";
import { IPaymentReponsetDtoModel } from "../models/payment/dto/payment-response-dto.model";
import { IJControlPaymentMethodDtoModel, IUpdateJControlPaymentMethodDtoModel } from "../models/payment/dto/jcontrol-payment-method-dto.model";

export class PaymentMapping implements IModelMapping<IPaymentReponsetDtoModel, IPaymentModel>  {
    toApplicationModel(model: IPaymentReponsetDtoModel): IPaymentModel {
        return {
            ...model
        } as IPaymentModel;
    }
    toDtoModel(model: IPaymentModel): IPaymentReponsetDtoModel {
        return {
            ...model
        } as IPaymentReponsetDtoModel;
    }
    toDtoModels(models: IPaymentModel[]): IPaymentReponsetDtoModel[] {
        return models.map(model => this.toDtoModel(model));
    }
    toApplicationModels(models: IPaymentReponsetDtoModel[]): IPaymentModel[] {
        return models.map(model => this.toApplicationModel(model));
    }

    toJControlPaymentMethodModel(model: ILookUpType): IJControlPaymentMethodDtoModel {
        return {
            code: model.code,
            name: model.name
        } as IJControlPaymentMethodDtoModel
    }

    updateJControlPaymentMethodModel(model: ILookUpType): IUpdateJControlPaymentMethodDtoModel {
        return {
            fieldToUpdate: 'defaultPaymentMethod',
            defaultPaymentMethod: {
                code: model.code,
                name: model.name
            } as IJControlPaymentMethodDtoModel
        }
    }
}

